module.exports = __webpack_public_path__ + "static/media/monetization_on-black-18dp.dec0be11.svg";